import React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment-timezone';

const LineLevelBoardTable = () => {

  const { current } = useSelector((state) => state?.plant);
  const { plant } = useSelector(state => state?.plant?.current)
  const { stats } = useSelector((state) => state.kpis);

  const currentSelectedDate = stats?.time
  const shiftWiseTarget = stats?.shiftWiseTarget; 
  const formattedShiftWiseTarget = typeof shiftWiseTarget === 'number' ? shiftWiseTarget.toFixed(0) : shiftWiseTarget;
    let lastTarget = 0;
  let lastGoodOutput = 0;
  let lastRowValues = {shortFall:0,Actual_Output:0,revisedHourlyTarget:0,Oee:0}

  return (
    <div className="custom-table">
      <table className="lineTable">
        <thead>
          <tr className="table-row">
          <th className="table-cell" colSpan="2">Date: {currentSelectedDate ? moment(currentSelectedDate).format('DD/MM/YYYY') : 'N/A'}</th>
          </tr>
        </thead>
        <tbody>
          <tr className="table-row">
            <th className="table-cell">Current OEE</th>
            <td className="table-cell">{lastRowValues ? lastRowValues.Oee+`%`: stats?.oeeFinal ? stats?.oeeFinal+`%` : 'N/A'}</td>
          </tr>
          <tr className="table-row">
            <th className="table-cell" style={{background:(lastTarget )?((lastGoodOutput - lastTarget)>0?'green':'red'):stats?.manualShift?'black':'black'}}>Current Hourly Variance</th>
            <td className="table-cell">{lastTarget ? (parseInt(lastGoodOutput) - lastTarget).toFixed(0):stats?.manualShift ? 'N/A' : 'N/A'}</td>
          </tr>
          <tr className="table-row">
            <th className="table-cell">Total Current Output</th>
            <td className="table-cell">{lastGoodOutput?(lastGoodOutput).toFixed(0):stats?.goodOutput}</td>
          </tr>
          <tr className="table-row">
            <th className="table-cell">Current Target</th>
            <td className="table-cell">{lastTarget ? lastTarget : formattedShiftWiseTarget}</td>
          </tr>
          <tr className="table-row">
            <th colSpan='2' className="table-cell">Shift Summary</th>
          </tr>
          <tr className="table-row">
            <th className="table-cell">OEE</th>
            <td className="table-cell">{stats?.oeeFinal ? stats?.oeeFinal+`%` : 'N/A'}</td>
          </tr>
          <tr className="table-row">
            <th className="table-cell">Target OEE</th>
            <td className="table-cell">{current?.machine && current?.machine?.targetOee ? ((current?.machine?.targetOee).toFixed(2) + '%') : current?.line?.targetOee ? ((current?.line?.targetOee).toFixed(2)+'%') : 'N/A'}</td>
          </tr>
          <tr className="table-row">
            <th className="table-cell">Variance</th>
            <td className="table-cell">{stats?.manualShift ? 'N/A' : (stats?.goodOutput - stats?.shiftWiseTarget).toFixed(0)}</td>
          </tr>
          <tr className="table-row">
            <th className="table-cell">Total Actual Output</th>
            <td className="table-cell">{stats?.goodOutput}</td>
          </tr>
          <tr className="table-row">
            <th className="table-cell">Daily Target</th>
            <td className="table-cell">{formattedShiftWiseTarget}</td>

          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LineLevelBoardTable;
